import React from "react";
import { Col, Row } from "antd";
import FadeInImage from "../Images/FadeInImage";
import dayjs from "dayjs";
import { KEYS } from "../../Config/Keys";
import { useLocation, useNavigate } from "react-router-dom";

const PastEventCard = ({ data }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentUser = pathname.includes("player") ? "player" : "organizer";
  const eid = data?._id || 123;
  return (
    <Row
      className="sideItem"
      style={{ cursor: "pointer", padding: "0" }}
      onClick={() => {
        if (currentUser === "player") {
          navigate(`/view/event/${eid}/timeline`, { state: "event" });
        } else if (currentUser === "organizer") {
          navigate(`/${currentUser}/event/${eid}/timeline`, { state: "event" });
        }
      }}>
      <FadeInImage
        radiusAll
        type={"FadesideItem150"}
        src={
          data?.file?.fileUrl ? KEYS.API + data?.file?.fileUrl : KEYS.API + data?.eventFile?.fileUrl
        }
        className="sideImageHeight"
        fallaback="/images/subevent.png"
      />
      <Col lg={24} md={24} xs={24} sm={24}>
        <div style={{ padding: "5px 20px" }}>
          <p
            style={{
              fontSize: "15px",
              marginTop: "10px",
              marginBottom: "4px",
              fontWeight: "500"
            }}>
            {data?.name || data?.eventName || "-"}
          </p>
          <p style={{ fontSize: "11px", marginTop: "5px", marginBottom: "2px", color: "#6F6F6F" }}>
            {data?.startDate ? dayjs(data?.startDate).format("DD MMMM") : "- no date"} -{" "}
            {data?.endDate ? dayjs(data?.endtDate).format("DD MMMM") : "- no date"}
          </p>
          <p
            style={{
              fontSize: "13px",
              color: "#0085FF",
              marginBottom: "2px",
              fontWeight: "500"
            }}>
            {data?.panel?.name || data?.panel}
          </p>
        </div>
      </Col>
    </Row>
  );
};

export default PastEventCard;
